import { mapActions, mapState } from 'vuex';
import CustomerRatePlatform from '@/components/Modals/CustomerRatePlatform.vue';

export default {
  computed: {
    ...mapState('auth', ['isAuthenticated', 'user']),
    ...mapState('rate_platform', ['rateableOrder']),
  },

  methods: {
    ...mapActions('rate_platform', ['checkRateableOrder']),

    openCustomerFeedbackModal() {
      this.$modal.show(CustomerRatePlatform, {}, {
        width: 600,
        height: 690,
        clickToClose: false,
      });
    }
  },

  async mounted () {
    if (this.user.isCustomer) {
      await this.checkRateableOrder();

      if (this.rateableOrder.exist) {
        this.openCustomerFeedbackModal();
      }
    }
  }
}
